import { CLEAR_REF_CAMPAIGNS, GET_REF_CAMPAIGNS_WITH_PAGINATION, SEARCH_REF_CAMPAIGNS } from '../types/refCampaignTypes';
import { ACCOUNT_LOGOUT } from '../types/accountTypes';
import initialState from '../../store/initialState';

const refCampaignReducer = function (state = initialState.refCampaign, action) {
  switch (action.type) {
    case GET_REF_CAMPAIGNS_WITH_PAGINATION:
      return {
        ...state,
        refCampaigns: action.payload.campaigns,
        pageNumber: action.payload.pageNumber,
        totalCount: action.payload.totalCount,
        pageSize: action.payload.pageSize || state.pageSize,
      };
    case SEARCH_REF_CAMPAIGNS:
      return {
        ...state,
        refCampaigns: action.payload.campaigns,
        pageNumber: action.payload.pageNumber,
        totalCount: action.payload.totalCount,
        pageSize: action.payload.pageSize || state.pageSize,
      };

    case CLEAR_REF_CAMPAIGNS:
    case ACCOUNT_LOGOUT:
      return {
        ...initialState.refCampaign,
      };
    default:
      return state;
  }
};

export default refCampaignReducer;
